export default __webpack_public_path__ + "static/media/anchor.b11cc36d.png";